<template>

  <div class="col p-0">
    <router-view></router-view>
  </div>

</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gider/odeme.vue